import SharedDownloadView, { type SharedDownloadAction, type SharedDownloadImage } from "../../sharedComponents/downloadView"
import watchFrame from "./assets/watchFrame.png"

import s_preview_1 from "./assets/s_preview_1.jpg"
import s_preview_2 from "./assets/s_preview_2.jpg"
import summer_preview_1 from "./assets/summer_preview_1.jpg"
import summer_preview_2 from "./assets/summer_preview_2.jpg"

interface DownloadViewProps {
    type?: string
}

interface ThemeAsset {
    isAvailable: boolean
    deepLink: string
    preview_1: string
    preview_2: string
}


const assets: Record<string, ThemeAsset> = {
    spring: {
        deepLink: "https://play.google.com/store/apps/details?id=com.watchfacestudio.spring_campus_with_dodu",
        preview_1: s_preview_1,
        preview_2: s_preview_2,
        isAvailable: false
    },
    summer: {
        deepLink: "https://play.google.com/store/apps/details?id=com.watchfacestudio.summer_campus_with_dodu",
        preview_1: summer_preview_1,
        preview_2: summer_preview_2,
        isAvailable: false
    },
    night: {
        deepLink: "",
        preview_1: "",
        preview_2: "",
        isAvailable: false
    },
    autumn: {
        deepLink: "",
        preview_1: "",
        preview_2: "",
        isAvailable: false
    },
    winter: {
        deepLink: "",
        preview_1: "",
        preview_2: "",
        isAvailable: false
    }
}

const WatchPreview = ({ preview, alt }: { preview: string; alt: string }) => (
    <div className="flex h-full w-full items-center justify-center">
        <div className="relative aspect-[9/16] h-full max-h-full max-w-full">
            <img
                src={preview}
                className="absolute left-[calc(50%-2.5px)] top-1/2 z-0 w-[73%] max-w-none -translate-x-1/2 -translate-y-1/2 object-contain md:w-[74%]"
                alt={alt}
            />
            <img
                src={watchFrame}
                className="relative z-10 h-full w-full object-contain"
                alt="DODU watch frame"
            />
        </div>
    </div>
)

const DownloadView = ({ type = "spring" }: DownloadViewProps) => {
    const current = assets[type] || assets.spring
    const images: SharedDownloadImage[] = [
        {
            component: <WatchPreview preview={current.preview_1} alt="DODU watch preview 1" />,
            caption: "BACKGROUND 1"
        },
        {
            component: <WatchPreview preview={current.preview_2} alt="DODU watch preview 2" />,
            caption: "BACKGROUND 2"
        }
    ]

    const actions: SharedDownloadAction[] = [
        {
            id: "play-store-watch-1",
            label: "다운로드",
            variant: "solid",
            href: current.deepLink
        },
    ]

    return (
        <SharedDownloadView
            isAvailable={current.isAvailable}
            images={images}
            actions={actions}
        />
    )
}

export default DownloadView
